import React from "react";
import { Route, Switch } from "react-router";
import { Routes } from "../../../constants/routes";
import AuthRoute from "../../auth/components/routes/AuthRoute";
import BillingPageWrapper from "../../billing/BillingPageWrapper";
import NotFound from "../../pages/NotFound";
import ApplicationRoutes from "../../application";
import HomePage from "../../pages/home";
import { Statistics } from "../../statistics";
import ServiceAdminRoutes from "../../services-admin";
import { AcademicsRoutes } from "../../academic";
import { LanguageCoursesRoutes } from "../../language-course";
import { ServicesRoutes } from "../../services";
import { StudentsRoutes } from "../../student";
import { ProgramsRoutes } from "../../program";
import { MessagesRoutes } from "../../message";
import DegreeRoutes from "../../degree";
import { Schools as SchoolRoutes } from "../../school";
import { BranchRoutes } from "../../branch";
import MajorRoutes from "../../major";
import UsersRoutes from "../../user";
import ExamRoutes from "../../exam";
import { Broadcast } from "../../broadcast";
import { PrivateClassesRoutes } from "../../privateClasses";

export default function Dashboard({ prefix }: { prefix: string }) {
  return (
    <Switch>
      <AuthRoute exact path={prefix} component={HomePage} />

      <ApplicationRoutes path={`${prefix}/${Routes.APPLICATIONS}`} />

      <MajorRoutes path={`${prefix}/${Routes.MAJORS}`} />

      <ExamRoutes path={`${prefix}/${Routes.EXAMS}`} />

      <DegreeRoutes path={`${prefix}/${Routes.DEGREES}`} />

      <ServiceAdminRoutes path={`${prefix}/${Routes.SERVICES_ADMIN}`} />

      <SchoolRoutes path={`${prefix}/${Routes.SCHOOLS}`} />

      <BranchRoutes path={`${prefix}/${Routes.BRANCHES}`} />

      <AcademicsRoutes path={`${prefix}/${Routes.ACADEMICS}`} />

      <ProgramsRoutes path={`${prefix}/${Routes.PROGRAMS}`} />

      <PrivateClassesRoutes path={`${prefix}/${Routes.PRIVATE_CLASSES}`} />

      <LanguageCoursesRoutes path={`${prefix}/${Routes.LANGUAGE_COURSES}`} />

      <ServicesRoutes path={`${prefix}/${Routes.SERVICE_LIST}`} />

      <StudentsRoutes path={`${prefix}/${Routes.STUDENTS}`} />

      <UsersRoutes path={`${prefix}/${Routes.USERS}`} />

      <AuthRoute
        path={`${prefix}/${Routes.BILLING}`}
        component={BillingPageWrapper}
      />

      <MessagesRoutes path={`${prefix}/${Routes.MESSAGES}`} />

      <Statistics path={`${prefix}/${Routes.STATISTICS}`} />

      <Broadcast path={`${prefix}/${Routes.BROADCAST}`} />

      <Route path={`${prefix}/*`} component={NotFound} />
    </Switch>
  );
}
